import universal from 'react-universal-component';
import universalImport from 'babel-plugin-universal-import/universalImport';
import path from 'path';
import { timeout } from '../../lazy/lazyConstants';

export default universal(
    universalImport({
        chunkName: () => 'FindStoresLazy',
        path: () => path.join(__dirname, './FindStores'),
        resolve: () => require.resolveWeak('./FindStores'),
        load: () =>
            Promise.all([import(/* webpackChunkName: "FindStoresLazy" */ './FindStores')]).then(
                (proms) => proms[0]
            ),
    }),
    {
        loading: () => null,
        error: () => null,
        timeout,
    }
);
